import styled, { css } from 'styled-components';
import { BASEMAP_TILE_HEIGHT } from '@rsos/components/capstone/BasemapMenu/BasemapMenu.styles';
import { Absolute } from '@rsos/components/capstone/base';
import { StyledMapCardHeader } from '@rsos/components/capstone/common/Map/MapCardHeader/MapCardHeader';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { StyledMapCard } from '../Map/MapCard/MapCard';

const SPACING = 16;
const ESRI_BASEMAP_TOGGLE_SPACING = 94; // the height + 30px absolute position
const GOOGLE_LOGO_SPACING = 26;

export const StyledContainer = styled(Absolute).attrs({
  top: `${SPACING}px`,
  left: `${SPACING}px`,
  zIndex: 2,
})`
  border-radius: 5px;
  ${({ isEventPaneCollapsed }) => {
    if (isEventPaneCollapsed) {
      return css`
        margin-left: -8px;
        margin-top: 100px;
      `;
    }
  }}
  ${({ hasEsriMapAccess, mapRef }) => {
    const mapHeight = mapRef?.current?.offsetHeight || 0;
    if (!mapHeight) {
      // Fall back to existing adr card styles if mapHeight is falsy
      return css`
        max-height: 410px;
        @media (max-width: ${BP_LAPTOP}px) {
          max-height: 300px;
        }
      `;
    } else if (hasEsriMapAccess) {
      return `max-height: ${
        mapHeight - SPACING * 2 - ESRI_BASEMAP_TOGGLE_SPACING
      }px`;
    }
    return `max-height: ${
      mapHeight - SPACING * 2 - GOOGLE_LOGO_SPACING - BASEMAP_TILE_HEIGHT
    }px`;
  }};

  max-width: 320px;
  @media (max-width: ${BP_LAPTOP}px) {
    max-width: 250px;
  }
  overflow-y: auto;
  width: 100%;
  word-break: break-word;
  background: ${({ theme }) => theme.colors.background};
`;

export const SpatialLayerCardContainer = styled.div`
  ${StyledMapCard} {
    width: 100%;
  }
  ${StyledMapCardHeader} {
    border-bottom: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
    margin-bottom: 0;
    padding: 16px;
  }
`;
